import { apiGet } from '../../MainModule/common/apiTools';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { IPassportMassDeleteReason } from '../interfaces/IPassportMassDeleteReason';

export async function fetchPassportMassDeleteReasons(): Promise<IPassportMassDeleteReason[]> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, false)}/catalogs/passport-mass-delete-reason`);
}
